import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./FeaturedBusinessesCarousel.css";
import { API_BASE_URL } from "../../config";

//const API_BASE_URL = "https://your-api-url.com"; // Update this with your actual API URL

const FeaturedBusinessesCarousel = () => {
  const [businesses, setBusinesses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFeaturedBusinesses = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/Business/getFeaturedBusinesses`);

        console.log(response.data);
        setBusinesses(response.data);
      } catch (error) {
        console.error("Error fetching businesses:", error);
      }
    };

    fetchFeaturedBusinesses();
  }, []);

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="featured-professionals">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h2 className="inner-page-heading">Featured Businesses</h2>
            <p className="inner-heading-desc">
              These local businesses have made an impact this week. Join them and get seen!
            </p>

            <div className="featured-business-carousel">
              {businesses.length > 0 ? (
                <Slider {...sliderSettings}>
                  {businesses.map((biz) => (
                    <div key={biz.businessUserId} className="biz-box">
                      <figure className="biz-image">
                        <img src={biz.profileImage || "/default-image.jpg"} alt={biz.BusinessName} />
                      </figure>
                      <div className="biz-data">
                        <p className="biz-name">{biz.businessName}</p>
                        <p className="biz-postcode">Postcode: {biz.postCode}</p>
                        <p className="biz-phone">Phone: {biz.businessPhone || "N/A"}</p>
                        <p className="biz-rating">Rating: {biz.overallRating || "No rating yet"}</p>
                        <button className="learn-button" onClick={() => navigate(`/business/${biz.businessUserId}`)}>
                          Learn More
                        </button>
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <p>No Featured Businesses Available</p>
              )}
            </div>

            <div className="d-flex justify-content-center">
              <button className="theme_btn" onClick={() => navigate("/register-business-user")}>
                List Your Business Today!
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBusinessesCarousel;